import { apiAction } from 'apa/actions'
import * as types from 'catalog/actions/types'

export const fetchMeasureList = () => (dispatch, getState) => {
  const checkpointId = getState().categories.activeCheckpoint.id
  dispatch(apiAction({
    url: `/api/measures/?checkpointId=${checkpointId}`,
    method: 'GET',
    onSuccess: measureList => ({
      type: types.FETCH_MEASURE_LIST,
      payload: {
        measureList: measureList
      }
    })
  }))
}

export const updateMeasure = (measure) => dispatch =>
  dispatch(apiAction({
    url: `/api/measures/${measure.id}/`,
    method: 'PATCH',
    data: measure,
    onSuccess: () => {
      dispatch(fetchMeasureList())
      return {
        type: types.UPDATE_MEASURE,
      }
    }
  }))

export const remove = (measure) => (dispatch, getState) => {
  const measureList = getState().categories.measureList
  dispatch(
    apiAction({
      url: `/api/measures/${measure.id}/`,
      method: 'DELETE',
      onSuccess: () => ({
        type: types.MEASURE_DELETED,
        payload: {
          measureList: measureList.filter(el => el.id !== measure.id)
        }
      })
    })
  )
}

export const updateTags = (measure, activeTags) => (dispatch) => {
  dispatch(apiAction({
    url: `/api/measures/${measure.id}/tags/`,
    method: 'POST',
    data: { activeTags },
    onSuccess: () => {
      dispatch(fetchMeasureList())
      return {
        type: types.UPDATE_MEASURE_TAGS,
      }
    }
  }))
}

export const add = (measure) => (dispatch, getState) => {
  const measureList = getState().categories.measureList
  const activeCheckpoint = getState().categories.activeCheckpoint
  dispatch(
    apiAction({
      url: '/api/measures/',
      method: 'POST',
      data: { checkpoint: activeCheckpoint.id, name: measure },
      onSuccess: measure => {
        return {
          type: types.ADD_MEASURE,
          payload: {
            measureList: [...measureList, measure]
          }
        }
      }
    })
  )
}

export const change = (measure) => (dispatch, getState) => {
  const measureList = getState().categories.measureList
  dispatch({
    type: types.CHANGE_MEASURE,
    payload: {
      measureList: measureList.map(el => el.id === measure.id ? measure : el)
    }
  })
} 

export const reorderMeasureList = result => (dispatch, getState) => {
  const state = getState()
  const source = result.source.index;
  const destination = result.destination.index;
  const measureList = [...state.categories.measureList]
  const [removed] = measureList.splice(source, 1);
  measureList.splice(destination, 0, removed);
  dispatch({
    type: types.REORDER_MEASURES,
    payload: {
      measureList: measureList
    }
  });
  dispatch(apiAction({
    url: '/api/measures/reorder/',
    method: 'POST',
    data: measureList.map(el => el.id),
    onSuccess: () => {
      dispatch(fetchMeasureList())
      return {
        type: types.REORDER_MEASURES,
        payload: {
          measureList: measureList
        }
      }
    }
  }))
}
